import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  saveShiftManager,
  cancelShiftManagerEdit,
} from "../../../reducers/shiftManagerManagement/thunkActions";
import {
  shiftManagerEditCopySelector,
  shiftManagerEditSelector,
  isShiftManagerEditValidSelector,
} from "../../../reducers/shiftManagerManagement/selectors";

import { View } from "../../View";
import { CancelSaveActionButtons } from "../Common/CancelSaveActionButtons";

const LockComponent = () => {
  const dispatch = useDispatch();
  const shiftManagerEdit = useSelector(shiftManagerEditSelector);
  const shiftManagerChanged =
    shiftManagerEdit !== useSelector(shiftManagerEditCopySelector);
  const isShiftManagerValid = useSelector(isShiftManagerEditValidSelector);

  const shouldDisableSave = () =>
    !shiftManagerEdit || !shiftManagerChanged || !isShiftManagerValid;

  return (
    <View>
      <View>
        {shiftManagerEdit && (
          <CancelSaveActionButtons
            onCancelClick={() => dispatch(cancelShiftManagerEdit())}
            onSaveClick={() => dispatch(saveShiftManager())}
            saveDisabled={shouldDisableSave()}
          />
        )}
      </View>
    </View>
  );
};

export default LockComponent;
